export default "__VITE_ASSET__fJ0PJHlJ__"